










import { defineComponent } from '@vue/composition-api';

import { Button } from '@kibt/meta-ui';

import networkErrorImg from '@/assets/images/networkError.png';

export default defineComponent({
    components: {
        Button,
    },
    setup() {
        return {
            networkErrorImg,
        };
    },
});
